import { useCallback } from "react";
import {
    CardStyleInterpolators,
    StackCardInterpolationProps,
    StackCardInterpolatedStyle,
} from "@react-navigation/stack";
import { Platform } from "react-native";

export const useCardStyleInterpolator = () => {
    const cardStyleInterpolator = useCallback<
        (props: StackCardInterpolationProps) => StackCardInterpolatedStyle
    >(({ ...props }) => {
        const {
            containerStyle = {},
            cardStyle = {},
            overlayStyle = {},
            shadowStyle = {},
        } = (
            Platform.OS !== "web"
                ? CardStyleInterpolators.forHorizontalIOS(props)
                : CardStyleInterpolators.forNoAnimation()
        ) as {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            containerStyle: Record<string, any>;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            cardStyle: Record<string, any>;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            overlayStyle: Record<string, any>;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            shadowStyle: Record<string, any>;
        };

        const backgroundColor = props.current.progress.interpolate({
            inputRange: [0, 1],
            outputRange: ["rgba(0, 0, 0, 0.0)", "rgba(0, 0, 0, 0.2)"],
            extrapolate: "clamp",
        });

        return {
            containerStyle: {
                ...containerStyle,
                backgroundColor,
            },
            cardStyle: { ...cardStyle },
            overlayStyle: { ...overlayStyle, opacity: 0 },
            shadowStyle: { ...shadowStyle },
        };
    }, []);

    return cardStyleInterpolator;
};
